import React, { FC } from "react";
import { CSS_CLASSES } from "./tab-css-classes";

export const TabList: FC = ({ children, ...restProps }) => {
  return (
    <div className={CSS_CLASSES.TAB_LIST} role="tablist" aria-label="Tablist" {...restProps}>
      {children}
    </div>
  );
};
